import styled from "styled-components";
import { Flex, FlexSpan, Icon } from "@evergis/ui";
import { PieChart as PieChartUI } from "@evergis/charts";

export const SpecialFilterOverlay = styled.div<{ bottomHeight: number }>`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: ${({ bottomHeight }) => `${bottomHeight}px`};
  background-color: transparent;
  z-index: 101;
`;

export const SpecialFilterContainer = styled.div<{ bottomHeight: number }>`
  position: absolute;
  left: 1rem;
  bottom: ${({ bottomHeight }) => `${bottomHeight - 80}px`};
  width: calc(100% - 2rem);
  height: 13.5rem;
  background: ${({ theme: { palette } }) => palette.background};
  box-shadow: 0 0.1875rem 0.625rem rgba(0, 0, 0, 0.15);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  z-index: 102;
  padding: 1rem;
  box-sizing: border-box;
`;

export const SpecialFilterHeader = styled(Flex)`
  align-items: center;
  height: 3rem;
`;

export const SpecialFilterHeaderInfo = styled(FlexSpan)`
  display: flex;
  flex-wrap: wrap;
  width: 50%;
`;

export const SpecialFilterHeaderWorkarea = styled(Flex)`
  align-items: center;
  width: 50%;
`;

export const SpecialFilterHeaderInputs = styled(FlexSpan)`
  display: flex;
  flex-wrap: nowrap;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  width: 50%;
`;

export const SpecialFilterHeaderInput = styled(FlexSpan)`
  display: flex;
  flex-wrap: nowrap;
  flex-grow: 1;
  align-items: center;
  width: calc(100% - 7.5rem);
`;

export const SpecialFilterHeaderNumberInput = styled.div`
  width: calc(50% - 0.5rem);
`;

export const SpecialFilterActions = styled.div`
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-left: 0.5rem;
`;

export const SpecialFilterStatBlock = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 12px;
  color: ${({ theme: { palette } }) => palette.textPrimary};
  margin-right: 1.25rem;
  margin-bottom: 0.25rem;
  box-sizing: border-box;
  cursor: default;

  ${Icon} {
    font-size: 12px;
    margin-right: 0.5rem;
    margin-top: -2px;
    color: ${({ theme: { palette } }) => palette.iconDisabled};
  }
`;

export const PieChart = styled(PieChartUI)`
  margin-right: 0.5rem;
`;
